export const CREATE_NEW_SCRIPT_ID = -1;
export const defaultOptions = [
  {
    title: 'Create a new script',
    scriptId: CREATE_NEW_SCRIPT_ID,
    content: '',
    sharedWithCompany: false,
    sharedWithAll: false,
  },
];
export const CAROUSEL_ITEMS_PER_PAGE = 4;
